import { Store } from 'vuex';
import AvsInBasket from '@/visa-application/models/AvsInBasket';

export default class BasketStoreService {
  private store: Store<{}>;

  constructor(store: Store<{}>) {
    this.store = store;
  }

  public getBasket(): AvsInBasket[] {
    return this.store.getters.getBasket();
  }

  public isAvsIntoBasket(avs: AvsInBasket): boolean {
    return this.store.getters.isAvsIntoBasket(avs);
  }

  public addAvsToBasket(avs: AvsInBasket): void {
    this.store.dispatch('addAvsToBasket', avs).catch(error => {
      console.error(error);
    });
  }

  public removeAvsFromBasket(avs: AvsInBasket): void {
    this.store.dispatch('removeAvsFromBasket', avs).catch(error => {
      console.error(error);
    });
  }

  public replaceBasketWithAvsList(avs: AvsInBasket[]): void {
    this.store.commit('replaceBasketWithAvsList', avs);
  }
}
